<template>
    <div>
        <Header />
        <NewArrivalAll />
        <div v-if="$store.state.hostName !== 'Q'">
            <Footer />
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import NewArrivalAll from '@/components/NewArrivalAll.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'NewArrivalView',

  components: {
    Header,
    NewArrivalAll,
    Footer
  }
}
</script>
